import { render } from "./FixedLoader.vue?vue&type=template&id=0485a698&scoped=true"
import script from "./FixedLoader.vue?vue&type=script&lang=js"
export * from "./FixedLoader.vue?vue&type=script&lang=js"

import "./FixedLoader.vue?vue&type=style&index=0&id=0485a698&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0485a698"]])

export default __exports__